/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientDemographicsChanged/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientDemographicsChanged({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/PatientDemographicsChanged"
  
}) {
  return null
}